<template>
  <div class="pt-3">
    <div class="d-flex justify-center container_calendar">
      <div class="half_w">
        <v-card class="rounded-lg pa-3 mb-3" min-height="200px" flat>
          <v-btn color="#fff" fab x-small depressed @click="$router.go(-1)">
            <v-icon>mdi-undo</v-icon>
          </v-btn>
          <div v-if="dataSet">
            <post-calendar :inventory="inventory" @success="fetchData" />
          </div>
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="loading"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="grey"
            ></v-progress-circular>
            <b class="grey--text">Loading....</b>
          </v-overlay>
        </v-card>
        <v-card class="rounded-lg pa-3 mb-3" flat>
          <h4 class="grey--text mb-3">Import Calendar</h4>
          <v-file-input
            hide-details
            v-model="file"
            background-color="#f1f3f4"
            prepend-inner-icon="mdi-upload"
            prepend-icon=""
            solo
            flat
            class="rounded"
            placeholder="Select file from your device"
          ></v-file-input>
          <v-btn
            depressed
            @click="importCalendar"
            color="#f1f3f4"
            class="text-capitalize mt-3"
          >
            Import
          </v-btn>
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="loadingImport"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="grey"
            ></v-progress-circular>
            <b class="grey--text">Loading....</b>
          </v-overlay>
        </v-card>
        <v-card class="rounded-lg pa-3" flat>
          <h4 class="grey--text mb-2">Share with people</h4>
          <div>
            <v-btn
              depressed
              dark
              @click="insertMember('scholar')"
              class="text-capitalize mr-2"
              color="blue"
            >
              <b>+ Add Scholar</b>
            </v-btn>
            <v-btn
              depressed
              dark
              @click="insertMember('tf')"
              class="text-capitalize mr-2"
              color="blue"
            >
              <b>+ Add TF</b>
            </v-btn>
            <v-btn
              depressed
              dark
              @click="insertMember('vendor_user')"
              class="text-capitalize mr-2"
              color="blue"
            >
              <b>+ Add Vendor</b>
            </v-btn>
          </div>
          <div class="mt-3">
            <v-card
              class="mb-2 d-flex list_gc"
              color="#f1f3f4"
              flat
              v-for="(item, i) in acl"
              :key="`acl-${i}`"
            >
              <div v-if="i != 0" class="pa-2" style="width: 100%">
                <v-row>
                  <v-col cols="12" md="10">
                    <div class="d-flex align-center">
                      <v-avatar
                        size="35"
                        class="mr-3"
                        v-if="item.scope.profile"
                      >
                        <img
                          :src="
                            item.scope.profile.profile_picture
                              ? item.scope.profile.profile_picture
                              : ava
                          "
                          class="obj_fit"
                          alt="isyan"
                        />
                      </v-avatar>
                      <div>
                        <b v-if="item.scope.profile"
                          >{{ item.scope.profile.name }}
                        </b>
                        <p class="default_txt">{{ item.scope.value }}</p>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="2">
                    <div
                      class="d-flex justify-end"
                      v-if="item.role !== 'owner'"
                    >
                      <v-btn
                        icon
                        color="red"
                        small
                        @click="deleteData(item.id)"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="loadingMember"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="grey"
            ></v-progress-circular>
            <b class="grey--text">Loading....</b>
          </v-overlay>
        </v-card>
        <div class="pa-2">
          <v-snackbar v-model="deleting" left :timeout="-1">
            {{ msg }}
          </v-snackbar>
          <dialog-calendar
            :d_gc="d_gc"
            @refetch="getAcl"
            @close="d_gc = false"
            :inventory="inventory"
            :type="d_type"
            :title="d_title"
            :width="d_width"
          />
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogCalendar from "./dialogCalendar.vue";
import { mapState } from "vuex";
import PostCalendar from "./postCalendar.vue";

export default {
  name: "calednarDetail",
  components: { dialogCalendar, PostCalendar },
  computed: {
    ...mapState({
      ava: (state) => state.ava,
    }),
  },
  mounted() {
    this.gat = localStorage.getItem("gat");
    this.fetchData();
    this.getAcl();
    this.loadingImport = true;
  },
  data() {
    return {
      dataSet: null,
      gat: null,
      acl: null,
      file: null,
      loading: false,
      loadingMember: false,
      loadingImport: false,
      deleting: false,
      msg: "",
      // dialog stuff
      inventory: null,
      d_type: "",
      d_title: "",
      d_gc: false,
      d_width: "450px",
    };
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `calendar/google/calendar-detail?calendar_id=${this.$route.params.id}&email=${this.gat}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          let isExist = data.summary.includes("LMS TANOTO");
          if (isExist) {
            data.summary = data.summary.replaceAll("LMS TANOTO", "");
          }
          this.inventory = {
            email: this.gat,
            calendar_id: this.$route.params.id,
            title: data.summary,
            description: data.description,
          };
          this.dataSet = data;
          this.loading = false;
          this.loadingImport = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
          this.loadingImport = false;
        });
    },

    getAcl() {
      this.loadingMember = true;
      let data = {
        path: `calendar/google/calendar-acl-list?calendar_id=${this.$route.params.id}&email=${this.gat}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.acl = data;
          this.loadingMember = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loadingMember = false;
        });
    },
    importCalendar() {
      this.loadingImport = true;
      let body = new FormData();
      body.append("email", this.gat);
      body.append("file", this.file);
      body.append("calendar_id", this.$route.params.id);

      let data = {
        body: body,
        path: `calendar/google/calendar-event/import`,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.loadingImport = false;
          this.file = null;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loadingImport = false;
        });
    },
    insertMember(type) {
      this.inventory = {
        type: type,
      };
      this.d_title = "Share with people";
      this.d_width = "450px";
      this.d_type = "i_acl";
      this.d_gc = true;
    },

    deleteData(i) {
      this.msg = "unsharing...";
      this.deleting = true;
      let path = "calendar/google/calendar-acl-delete";
      let gat = localStorage.getItem("gat");
      let body = "";

      body = {
        email: gat,
        calendar_id: this.$route.params.id,
        acl_id: i,
      };

      let data = {
        path: path,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then(() => {
          this.msg = "unshared";
          this.getAcl();

          setTimeout(() => {
            this.deleting = false;
          }, 800);
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.container_calendar {
  font-family: "Montserrat", sans-serif;
  font-family: "Roboto", sans-serif;
}
.bg_vtf {
  background: #f1f3f4;
  border-radius: 5px;
}
</style>